import { Box } from "@mui/system";
import React, { useState, useEffect, useCallback } from "react";
import styles from "../components/trademarkgraph.module.scss";
import i18next from "i18next";
import { Tab, Tabs, Typography } from "@mui/material";
import _ from "lodash";
import { postTradeMarkGraph } from "../../../services/APIService";
import { useApiErrorModalContext } from "../../../errorHandling/ApiErrorModalContext";
import ReactBubbleChart from "react-d3-bubble";
import moment from "moment";

const currentmonth = new Date();

export default function TrademarkGraphComponent() {
  const [selectedTab, setSelectedTab] = useState(moment().format("MM"));

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const [trademarkValue, setTrademarkValue] = useState([]);

  const { setApiErrorModalState } = useApiErrorModalContext();

  const getTrademarkGraphValue = useCallback(() => {
    setTrademarkValue([]);

    postTradeMarkGraph({ year: currentmonth.getFullYear(), month: selectedTab })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          let radiusObj = getRadiusObj(response);

          let testAry = [
            {
              index: 0,
              name: "100%-OH",
              value: `€  ${response["100%-OH"]}`,
              color: "#0D86FF",
              radius: radiusObj["100%-OH"],
            },
            {
              index: 1,
              value: `€  ${response["CH&GO"]}`,
              name: "CH&GO",
              color: "#32CD32",
              radius: radiusObj["CH&GO"],
            },
            {
              index: 2,
              name: "BOIMP",
              value: `€  ${response["BOIMP"]}`,
              color: "#20B2AA",
              radius: radiusObj["BOIMP"],
            },
            {
              index: 3,
              value: `€  ${response["BOGAR"]}`,
              name: "BOGAR",
              color: "#ffc91c",
              radius: radiusObj["BOGAR"],
            },

            {
              index: 4,
              value: `€  ${response["KEURS"]}`,
              name: "KEURS",
              color: "#667085",
              radius: radiusObj["KEURS"],
            },
          ];

          setTrademarkValue(testAry);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab]);

  useEffect(() => {
    getTrademarkGraphValue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab]);

  const getRadiusObj = (response) => {
    let certificateObj = response;

    delete certificateObj["Month_Name"];
    delete certificateObj["Year"];
    delete certificateObj["Month"];

    const sortedBasedOnValue = Object.fromEntries(
      Object.entries(certificateObj).sort(([, a], [, b]) => a - b)
    );

    const radius = [38, 41, 44, 47, 50];
    Object.keys(sortedBasedOnValue).forEach((certificate,index) => {
      sortedBasedOnValue[certificate] = radius[index];
      return "";
    })
    // Object.keys(sortedBasedOnValue).map((certificate, index) => { will remove later
    //   sortedBasedOnValue[certificate] = radius[index];
    //   return "";
    // });
    return sortedBasedOnValue;
  };

  return (
    <>
      <Box
        className={styles.turngraphTableContainer}
        data-testid="TrademarkGraphComponent"
      >
        <Box>
          <Typography className={styles.trademarkOverheading}>
            {i18next.t("Turnover by trademark")}
            {`(${"€"})`}
          </Typography>
        </Box>
        <Box className={styles.GraphtabContainerheader}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            className={styles.toggelStyleTab}
            sx={{
              boxShadow:
                "0px 2px 4px 0px rgba(96, 97, 112, 0.16),0px 0px 1px 0px rgba(40, 41, 61, 0.04)",
            }}
          >
            <Tab
              label={i18next.t("Current month")}
              className={styles.selectedDay}
              value={moment().format("MM")}
            />
            <Tab
              label={i18next.t("Previous month")}
              className={styles.selectedDay}
              value={moment().format("MM") - 1}
            />
          </Tabs>
        </Box>
      </Box>
      <Box className={styles.buppleWraper}>
        {!_.isEmpty(trademarkValue) ? (
          <ReactBubbleChart data={trademarkValue} />
        ) : null}
      </Box>
    </>
  );
}
